// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4w-0";
export var eligibilityCardNotEligible = "_4w-1";